export const COMMODITY_MAP_SPAM = {
  ['arabic coffee']: 'COFF',
  ['coffee']: 'COFF',
  ['cocoa']: 'COCO',
  ['cocoa farm']: 'COCO',
  ['cocoa generic']: 'COCO',
  ['oilpalm']: 'OILP',
  ['palm oil']: 'OILP',
  ['palm oil plantation']: 'OILP',
  ['palm oil generic']: 'OILP',
  ['palm smallholder farm']: 'OILP',
  ['palm oil mill']: 'OILP',
  ['rubber']: 'RUBB',
  ['soybean']: 'SOYB',
  ['sugarcane']: 'SUGC',
  ['sugar cane']: 'SUGC',
  ['soy']: 'SOYB',
  ['soy silo']: 'SOYB',
  ['soy farm']: 'SOYB',
  ['soy generic']: 'SOYB',
};

export const MAPSPAM_COMMODITY = {
  COFF: 'Coffee',
  COCO: 'Cocoa',
  OILP: 'Palm Oil',
  RUBB: 'Rubber',
  SOYB: 'Soy',
  SUGC: 'Sugar Cane',
};
